// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import { React, useNavigate } from "../vendor/runtime.js";
import { AuthLayout } from "../components/auth/AuthLayout.jsx";
import { RegisterForm } from "../components/auth/RegisterForm.jsx";
const RegisterPage = () => {
  const { currentUser: a } = useAuth(),
    n = useNavigate();
  return (
    React.useEffect(() => {
      a && n("/products");
    }, [a, n]),
    (
      <AuthLayout>
        <RegisterForm />
      </AuthLayout>
    )
  );
};
export { RegisterPage };
